import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import artworksData from "../../data/artworks.json";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { useTranslation } from "../../context/TranslationsProvider";
import axios from "axios";

interface Product {
    id: number;
    product_title_lv: string;
    product_title_eng: string;
    product_title_ru: string;
    product_desc_lv: string;
    product_desc_eng: string;
    product_desc_ru: string;
    dimensions: string;
    price: string;
    main_image: string | null;
    created_at: string;
    is_sold: boolean;
}

const AllPaintings: React.FC = () => {

    const [data, setData] = useState<Product[]>([]);

    const [loader, setLoader] = useState<boolean>(true)

    const { translate, language } = useTranslation();

    const API_URL = `${process.env.REACT_APP_API_URL}`

    const fetchData = () => {
        axios.get(`${API_URL}/products`, {withCredentials: true})
            .then(response => {
                setData(response.data);
                setLoader(false)
            })
            .catch(errors => {
                setLoader(false)
                setData([])
            })
    }

    useEffect(()=>{
        fetchData()
    }, [])

    return (
        <div className="flex flex-col">
            <Header />
            <div className="flex flex-col items-center bg-[#f4f1ea] p-10 min-h-screen">
                <div className="container max-w-6xl flex flex-col">
                    <div className="flex justify-between flex-col md:flex-row md:items-center mb-8 border-b border-gray-500 pb-2">
                        <h1 className="font-bold text-lg text-gray-800">{translate("product_title")}</h1>
                        <h2 className="text-gray-800 text-sm">{translate("product_view_more_title")}</h2>
                    </div>
                    {loader ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-pulse">
                            {Array.from({ length: 3 }).map((_, index) => (
                                <div key={index} className="animate-pulse">
                                    <div className="w-full h-64 bg-zinc-300"></div>
                                    <div className="h-6 bg-zinc-300  mt-4 w-3/4"></div>
                                    <div className="h-4 bg-zinc-300 mt-2 w-1/2"></div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {data && Array.isArray(data) && data.map((item: Product, index: number) => (
                                <Link
                                    to={`/painting/${item.product_title_eng}`}
                                    key={index}
                                    className="block group"
                                >
                                    {item.main_image && (
                                        <img
                                            src={item.main_image}
                                            alt={item[`product_title_${language}` as keyof Product] as string}
                                            className="w-full h-auto group-hover:opacity-75 transition"
                                        />
                                    )}
                                    <h2 className="text-lg font-semibold mt-4 text-gray-800">
                                        {item[`product_title_${language}` as keyof Product]}
                                    </h2>
                                    <p className="text-sm text-gray-700">
                                        {item.is_sold ? item.price + " €" : translate("sold")} | {item.dimensions} cm
                                    </p>
                                </Link>
                            ))}
                        </div>
                    )}
                    {!loader && data.length === 0 && (
                        <h1 className="self-center text-gray-800 py-6">{translate("product_empty_error")}</h1>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default AllPaintings;
